import http from "@/helper/http";
import api from "@/helper/api";

const defaultGoodsReceipts = () => ({
  items: [],
  total: 0,
  page: 1,
  pages: 0,
});

export default {
  state: {
    goodsReceipts: defaultGoodsReceipts(),
    goodsReceipt: null,
    loadingGoodsReceipts: false,
    loadingCreateGoodsReceipt: false,
    loadingApproveGoodsReceipt: false,
    loadingRejectGoodsReceipt: false,
  },
  mutations: {
    SET_GOODS_RECEIPTS(state, payload) {
      state.goodsReceipts = payload || defaultGoodsReceipts();
    },
    SET_GOODS_RECEIPT(state, payload) {
      state.goodsReceipt = payload || null;
    },
    SET_LOADING_GOODS_RECEIPTS(state, value) {
      state.loadingGoodsReceipts = !!value;
    },
    SET_LOADING_CREATE_GOODS_RECEIPT(state, value) {
      state.loadingCreateGoodsReceipt = !!value;
    },
    SET_LOADING_APPROVE_GOODS_RECEIPT(state, value) {
      state.loadingApproveGoodsReceipt = !!value;
    },
    SET_LOADING_REJECT_GOODS_RECEIPT(state, value) {
      state.loadingRejectGoodsReceipt = !!value;
    },
    RESET_GOODS_RECEIPTS_STATE(state) {
      state.goodsReceipts = defaultGoodsReceipts();
      state.goodsReceipt = null;
    },
  },
  actions: {
    async listGoodsReceipts(
      { commit },
      { storeId, page = 1, per_page = 10, query = "", status, start_date, end_date }
    ) {
      if (!storeId) {
        commit("RESET_GOODS_RECEIPTS_STATE");
        throw new Error("A storeId is required to list goods receipts");
      }

      commit("RESET_GOODS_RECEIPTS_STATE");
      commit("SET_LOADING_GOODS_RECEIPTS", true);
      try {
        const params = { page, per_page, query };
        if (status) params.status = status;
        if (start_date) params.start_date = start_date;
        if (end_date) params.end_date = end_date;
        const { data } = await http.get(api.goods_receipts(storeId), { params });
        commit("SET_GOODS_RECEIPTS", data);
        return data;
      } catch (error) {
        commit("RESET_GOODS_RECEIPTS_STATE");
        throw error;
      } finally {
        commit("SET_LOADING_GOODS_RECEIPTS", false);
      }
    },
    async createGoodsReceipt({ commit }, { storeId, payload }) {
      commit("SET_LOADING_CREATE_GOODS_RECEIPT", true);
      try {
        const { data } = await http.post(api.goods_receipts(storeId), payload);
        return data;
      } finally {
        commit("SET_LOADING_CREATE_GOODS_RECEIPT", false);
      }
    },
    async getGoodsReceipt({ commit }, { storeId, receiptId }) {
      const { data } = await http.get(api.goods_receipt(storeId, receiptId));
      commit("SET_GOODS_RECEIPT", data);
      return data;
    },
    async approveGoodsReceipt(
      { commit },
      { storeId, receiptId, allow_over_delivery = false, client_reference }
    ) {
      commit("SET_LOADING_APPROVE_GOODS_RECEIPT", true);
      try {
        const body = { allow_over_delivery };
        if (client_reference) body.client_reference = client_reference;
        const { data } = await http.post(
          api.goods_receipt_approve(storeId, receiptId),
          body
        );
        return data;
      } finally {
        commit("SET_LOADING_APPROVE_GOODS_RECEIPT", false);
      }
    },
    async rejectGoodsReceipt({ commit }, { storeId, receiptId }) {
      commit("SET_LOADING_REJECT_GOODS_RECEIPT", true);
      try {
        const { data } = await http.post(
          api.goods_receipt_reject(storeId, receiptId)
        );
        return data;
      } finally {
        commit("SET_LOADING_REJECT_GOODS_RECEIPT", false);
      }
    },
  },
  getters: {
    goodsReceipts: (state) => state.goodsReceipts,
    goodsReceipt: (state) => state.goodsReceipt,
    loadingGoodsReceipts: (state) => state.loadingGoodsReceipts,
    loadingCreateGoodsReceipt: (state) => state.loadingCreateGoodsReceipt,
    loadingApproveGoodsReceipt: (state) => state.loadingApproveGoodsReceipt,
    loadingRejectGoodsReceipt: (state) => state.loadingRejectGoodsReceipt,
  },
};
